import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { applyHoverIn, applyHoverOut, colors, dimensions, ellipsisText, fonts, getStatusColor } from '../terminal-tokens';
const dropdownStyle = {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: 4,
    backgroundColor: colors.bgSurface,
    border: `1px solid ${colors.border}`,
    borderRadius: 6,
    boxShadow: `0 8px 24px ${colors.shadow}`,
    minWidth: dimensions.menuMinWidth,
    maxHeight: dimensions.menuMaxHeight,
    overflowY: 'auto',
    zIndex: 100,
    padding: '4px 0',
};
const baseItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: 13,
    fontFamily: fonts.ui,
    border: 'none',
    background: 'none',
    width: '100%',
    textAlign: 'left',
    transition: 'background-color 0.1s',
};
/**
 * Dropdown menu for tab overflow
 * Shows all terminals when there are too many tabs
 */
export const TabOverflowMenu = ({ sessions, activeSessionId, onSelect, onClose, }) => {
    const menuRef = useRef(null);
    // Close on click-outside or Escape key
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };
        const handleEscape = (event) => {
            if (event.key === 'Escape')
                onClose();
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);
    return (_jsx("div", { style: dropdownStyle, ref: menuRef, role: "menu", children: sessions.map((session) => {
            const isActive = session.id === activeSessionId;
            return (_jsxs("button", { style: {
                    ...baseItemStyle,
                    backgroundColor: isActive ? colors.bgHighlight : 'transparent',
                    color: isActive ? colors.fg : colors.fgMuted,
                }, onClick: () => onSelect(session.id), role: "menuitem", onMouseEnter: (e) => { if (!isActive)
                    applyHoverIn(e.currentTarget); }, onMouseLeave: (e) => { if (!isActive)
                    applyHoverOut(e.currentTarget); }, children: [_jsx("span", { style: {
                            fontSize: 8,
                            color: getStatusColor(session.status),
                            flexShrink: 0,
                        }, children: "\u25CF" }), _jsx("span", { style: {
                            ...ellipsisText,
                            flex: 1,
                        }, children: session.name }), session.workingDirectory && (_jsx("span", { style: {
                            fontSize: 11,
                            color: colors.fgDim,
                            flexShrink: 0,
                            maxWidth: 80,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }, title: session.workingDirectory, children: session.workingDirectory.split('/').pop() || '/' }))] }, session.id));
        }) }));
};
//# sourceMappingURL=TabOverflowMenu.js.map